import { regionDistrictData } from '../../../util/optionlist';
import React, { useState, useEffect, useRef } from 'react';

function PopupBtmSelectArea({ setisShowSelectArea, setisCompleteSelectArea, carInfo, setcarInfo }) {

  // 기존 코드
  const splitRegionDistrict = () => {
    const fullRegion = carInfo.carRegion || '';
    const parts = fullRegion.split(' ');
    return {
      region: parts[0],
      district: parts[1],
    };
  };

  const [selectedRegion, setSelectedRegion] = useState(splitRegionDistrict().region);
  const [selectedDistrict, setSelectedDistrict] = useState(splitRegionDistrict().district);
  const [isFormComplete, setIsFormComplete] = useState(true);

  const handleRegionSelect = (region) => {
    setSelectedRegion(region);
    setSelectedDistrict('');
    setIsFormComplete(false);
  };

  const handleDistrictSelect = (district) => {
    setSelectedDistrict(district);
    setIsFormComplete(true);
  };

  const handleComplete = () => {
    if (isFormComplete) {
      const updatedCarInfo = {
        ...carInfo,
        carRegion: `${selectedRegion}${selectedDistrict==='전체' ? '' : `${' ' + selectedDistrict}`}`,
      };

      setcarInfo(updatedCarInfo);
      setisCompleteSelectArea(true);
      setisShowSelectArea(false);
    }
  };

  const handleCancel = () => {
    setisShowSelectArea(false);
  };


  // 스와이프 관련 상태
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const dragHandleRef = useRef(null); // 드래그 핸들(상단 바)을 위한 ref

  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    // dragHandleRef가 터치 이벤트의 시작점을 포함하고 있는지 확인
    if (dragHandleRef.current?.contains(e.target)) {
      setTouchEnd(null);
      setTouchStart(e.targetTouches[0].clientY);
    }
  };

  const onTouchMove = (e) => {
    // touchStart가 있을 때만 동작 (즉, 드래그 핸들에서 시작된 터치일 때만)
    if (touchStart) {
      setTouchEnd(e.targetTouches[0].clientY);
    }
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchEnd - touchStart;
    const isDownSwipe = distance > minSwipeDistance;
    
    if (isDownSwipe) {
      setisShowSelectArea(false);
    }
  };

  return (
    <div className="fixed bg-[rgba(0,0,0,0.7)] top-0 left-0 w-full h-full flex items-end justify-center z-10">
      <div 
        className="bg-white w-full pb-5 pt-10 min-h-64 rounded-t-2xl max-w-screen-md max-h-[calc(100%-67px)] overflow-y-auto relative"
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      >
        {/* 드래그 핸들 영역에 ref 추가 */}
        <button 
          ref={dragHandleRef}
          className="absolute top-0 left-0 flex justify-center w-full h-10 pt-4 m-auto rounded-xl"
        >
          <span className="w-10 h-1 bg-[#E1E2E4] rounded-xl"></span>
        </button>

        <h3 className="text-[#1B1C1E] text-left font-semibold text-[22px] pl-5 border-b border-solid border-[#DBDCDF] pb-3">
          지역을 선택해주세요
        </h3>

        <div className="flex justify-center overflow-hidden h-96">
          {/* 지역 옵션 */}
          <div className="w-1/2 border-r border-solid border-[#DBDCDF] overflow-y-auto">
            {Object.keys(regionDistrictData).map((region) => (
              <button
                key={region}
                className={`h-[46px] bg-white pl-5 pr-6 flex justify-between items-center w-full border-b border-solid border-[#F2F2F7] ${
                  selectedRegion === region ? 'text-[#1B1C1E]' : 'text-[#8B8B9A]'
                }`}
                onClick={() => handleRegionSelect(region)}
              >
                <span>{region}</span>
                {selectedRegion === region && (
                  <img src="/assets/img/ico_select_arrow_right.svg" alt="arrow" />
                )}
              </button>
            ))}
          </div>

          {/* 구 옵션 */}
          <div className={`w-1/2 overflow-y-auto ${!selectedRegion && 'pointer-events-none opacity-50'}`}>
            {selectedRegion &&
              regionDistrictData[selectedRegion].map((district) => (
                <button
                  key={district}
                  className={`h-[46px] bg-white pl-5 pr-6 flex justify-between items-center w-full border-b border-solid border-[#F2F2F7] ${
                    selectedDistrict === district ? 'text-[#1B1C1E]' : 'text-[#8B8B9A]'
                  }`}
                  onClick={() => handleDistrictSelect(district)}
                >
                  <span>{district}</span>
                  <img 
                    src="/assets/img/ico_select_check_right.svg" 
                    alt="check" 
                    className={selectedDistrict === district ? '' : 'opacity-20'} 
                  />
                </button>
              ))}
          </div>
        </div>

        <div className="flex justify-between gap-[10px] border-t border-solid border-[#DBDCDF] pt-5 pl-5 pr-5">
          <button
            className="flex items-center justify-center w-full h-[52px] rounded-lg bg-[#F4F4F5] text-[#313A4C] font-semibold"
            onClick={() => handleCancel()}
          >
            취소
          </button>
          <button
            className={`flex items-center justify-center w-full h-[52px] rounded-lg ${
              isFormComplete ? 'bg-[#313A4C]' : 'bg-[#E1E2E4]'
            } text-white cursor-pointer font-semibold`}
            onClick={handleComplete}
            disabled={!isFormComplete}
          >
            완료
          </button>
        </div>
      </div>
    </div>
  );
}

export default PopupBtmSelectArea;